import React from "react"
import PropTypes from "prop-types"

import { PageHeading, PageSubHeading } from "../Typography/Typography"

const careTypes = {
  care_home: "care homes",
  home_care: "home care",
}

const toTitleCase = (str) =>
  str.replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(),
  )

const PageHeadingText = ({
  careType,
  locationName,
  noMarginBottom,
  useSansFont,
  careServiceType,
}) => {
  const careServiceTypeText = toTitleCase(
    careServiceType ? `${careServiceType} ` : "",
  )
  const careTypeText = toTitleCase(careTypes[careType] || "elderly care")
  const locationText = locationName || "your area"

  return (
    <>
      <PageHeading noMarginBottom={noMarginBottom} sans={useSansFont}>
        {careServiceTypeText}
        {careTypeText} in {locationText}
      </PageHeading>
      <PageSubHeading>Start your search now</PageSubHeading>
    </>
  )
}

PageHeadingText.propTypes = {
  careType: PropTypes.oneOf(["home_care", "care_home"]),
  locationName: PropTypes.string,
  noMarginBottom: PropTypes.bool,
  useSansFont: PropTypes.bool,
  careServiceType: PropTypes.oneOf(["dementia"]),
}

PageHeadingText.defaultProps = {
  careType: undefined,
  locationName: undefined,
  noMarginBottom: false,
  useSansFont: false,
  careServiceType: undefined,
}

export default PageHeadingText
